module.exports = __webpack_public_path__ + "img/education.0ef3b2a.jpg";